import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'
import * as bs from 'react-bootstrap'

/**
 * DrawerHeader - Unified header for drawer panels (Search, Glossary, Settings)
 * Matches AI Chat header style: title, bottom border, right-aligned Close button.
 */
const DrawerHeader = ({ title }) => {
  const handleClose = () => {
    // Use the same close event as AI chat drawer
    window.dispatchEvent(new CustomEvent('close-chat-drawer'))
  }

  return (
    <div className="drawer-header d-flex align-items-center">
      <div className="drawer-title flex-maximal card-title">
        {title}
      </div>
      <div className="flex-minimal d-flex">
        <span className="icon-container">
          <bs.Button
            variant="gray-tertiary"
            onClick={handleClose}
            className="flex-minimal icon-button"
            aria-label={formatMessage('Close')}
            title={formatMessage('Close the {title} drawer', { title })}
          >
            <i className="fa-light fa-times icon" aria-hidden="true"></i>
          </bs.Button>
        </span>
      </div>
    </div>
  )
}

DrawerHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default DrawerHeader
